import { DatePicker, Form, message, Modal, Typography } from "antd";
import K from "utilities/constants";
import { useState } from "react";
import Export from "redux/models/export";

const { Paragraph } = Typography;
const { RangePicker } = DatePicker;

export default function CommissionStatementExport({
  exportData,
  setExportData,
  clientIds = [],
  recruiterIds = [],
}) {
  const [loading, setLoading] = useState(false);

  const [form] = Form.useForm();

  const handleSuccess = () => {
    setExportData((prev) => ({ ...prev, isModalVisible: false }));
  };

  const handleExportCancel = () => {
    setExportData((prev) => ({ ...prev, isModalVisible: false }));
  };

  const afterModalClose = () => {
    form.resetFields();
  };

  const onFinish = async (values) => {
    const params = {
      recruiterIds,
      clientIds,
      range: [
        values.range[0].format(K.DateFormat.Response),
        values.range[1].format(K.DateFormat.Response),
      ],
    };

    setLoading(true);

    try {
      await Export.getReportCommissionStatements(params);

      message.success(
        "Commission Statements export request successfully received! Check your email shortly",
      );

      handleSuccess();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      centered
      className="s2-theme-style"
      title="Export Commission Statements"
      open={exportData.isModalVisible}
      onOk={form.submit}
      okButtonProps={{ loading }}
      onCancel={handleExportCancel}
      afterClose={afterModalClose}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={{
          exportType: "job",
          recruiterIds: recruiterIds ?? [],
        }}
      >
        <Paragraph>
          Kindly input a date range to export all commission statements within
          the specified range as a single CSV file.
        </Paragraph>
        <Form.Item
          label="Due Date"
          name="range"
          rules={[{ required: true, message: "Due Date is required" }]}
        >
          <RangePicker format={K.DateFormat.DashUSFormat} />
        </Form.Item>
      </Form>
    </Modal>
  );
}
